<template>
    <div :class="['footer', { 'footer--transparent': transparentBackground }]">
        <div class="payment-methods">
            <div class="payment-icons">
                <img src="../assets/Logos/Visa.png" alt="Visa Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
                <img src="../assets/Logos/MasterCard.png" alt="MasterCard Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
                <img src="../assets/Logos/Discover.png" alt="Discover Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
                <img src="../assets/Logos/Amex.png" alt="AMEX Credit Card Logo" width="70" height="44" loading="lazy" decoding="async">
            </div>  
            <p class="CCDisclaimer">
                We accept all major credit cards.
            </p>
        </div>
        <div class="contact-info">
            <p>Homes Roofing Co LLC</p>

            <div class="footer-locations">
                <div class="footer-location">
                    <h3>Southwest Michigan</h3>
                    <p>Niles, MI 49120</p>
                    <p><a href="tel:+12692625055">(269) 262-5055</a></p>
                </div>
                <div class="footer-location">
                    <h3>Northern Michigan</h3>
                    <p>Gaylord, MI 49735</p>
                    <p><a href="tel:+19898583559">(989) 858-3559</a></p>
                </div>
            </div>

            <p><a href="mailto:homesroofingco@gmail.com">homesroofingco@gmail.com</a></p>

            <a href="https://www.facebook.com/profile.php?id=100091999461722" target="_blank" rel="noopener">
                <p class="footerFacebook"> 
                    Check us out on Facebook:&nbsp;   
                    <img :src="Facebook" alt="Facebook" width="24" height="24" loading="lazy" decoding="async">
                </p>
            </a>

            <p class="copyright">© 2026 Homes Roofing Co LLC. All rights reserved.</p>
     
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'PageFooter',
    props: {
        transparentBackground: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            Facebook: require('@/assets/Logos/Facebook.png'),
        };
    },
}
</script>

<style scoped>

.payment-icons {
    display: flex;
    justify-content: space-between;

    img {
        width: 70px;
        height: auto; /* maintain aspect ratio */
        object-fit: contain; /* ensure the images fit within their box */
        border-radius: 5px; /* round the corners */
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15); /* add a shadow for depth */
        margin-right: 10px; /* add some space between the images */
    }
}
.footerFacebook{
    display: flex;
    align-items: center;
    justify-content: center; /* Center items horizontally */
    padding: 12px 10px; /* Add some padding - increased by 20% total */
    background-color: #3b5998; /* Facebook's brand color */
    color: white; /* White text color */
    border-radius: 5px; /* Rounded corners */
    text-decoration: none; /* Remove underline */
    transition: all 0.3s ease;
    }
    
.footerFacebook img {
    height: 1.2em; /* Match height to text size - increased by 20% total */
    width: auto;
}

.contact-info a {
    text-decoration: none;
}

.contact-info a:hover .footerFacebook {
    background-color: #2d4373; /* Darker blue on hover */
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-image: linear-gradient(to right, #002655, #89c2fc);
    color: #f5f5f5;
}

.footer--transparent {
    background: transparent;
    background-image: none;
}

.payment-methods {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 20px;
}

.contact-info {
    text-align: center;

    a {
        text-decoration: none;
    }
}


/* Media query for tablet and larger screens */
@media (min-width: 768px) {
    .footer {
        flex-direction: row;
        justify-content: space-around;
        display: flex;
    }

    .payment-methods {
        margin-bottom: 0;
        flex-direction: column;
    }



    .contact-info {
        text-align: left;
    }
}

   /* specific styling for Mobile */
   .contact-info {
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;

        a {
            color: #f1c40f;

            &:hover {
                text-decoration: underline;
                color: #ffffff;
            }
        }
   }
   .phone-button {
  display: inline-block;
  padding: 12px 30px;
  background-color: #8d0808;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  width: 100%;
}

.phone-button:hover {
  background-color: #0056b3;
}

.footer-locations {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 10px 0;
}

.footer-locations .footer-location h3 {
    margin: 0 0 4px;
    font-size: 1rem;
    color: #f1c40f;
}

.footer-locations .footer-location p {
    margin: 0;
}

@media (min-width: 480px) {
    .footer-locations {
        flex-direction: row;
        justify-content: center;
        gap: 32px;
    }
}

@media (min-width: 768px) {
    .footer-locations {
        justify-content: flex-start;
    }
}

</style>